const initialState = {
    //port List 
    loadingCCPortList: false,
    CCPortListDataError: "",
    CCPortListData: [],

    //custom house
    loadingCCCustomHouseList: true,
    CCCustomHouseListDataError: '',
    CCCustomHouseListData: [],

    //emp list
    loadingCCEmployeeList: true,
    CCEmployeeListDataError: '',
    CCEmployeeListData: [],

    // country list
    loadingCCCountryList: true,
    CCCountryListData: [],
    CCCountryListDataError: '',

    //custom clearance -> Export Job
    loadingCCExpJobDetail: true,
    CCExpJobDetailDataError: '',
    CCExpJobDetailData: {},

    //custom clearance -> Import Job
    loadingCCImpJobDetail: false,
    CCImpJobDetailData: {},
    CCImpJobDetailDataError: '',

    //custom clearance -> Export Job -> organisation detail
    loadingCCExpJobOrganisationList: true,
    CCExpJobOrganisationListData: [],
    CCExpJobOrganisationListDataError: '',

    //custom clearance -> Export Job -> organisation branch detail
    loadingCCExpJobShipperOrganisationBranchList: true,
    CCExpJobShipperOrganisationBranchListData: [],
    CCExpJobShipperOrganisationBranchListDataError: '',
    //custom clearance -> Export Job -> organisation reg detail
    loadingCCExpJobShipperOrganisationRegList: false,
    CCExpJobShipperOrganisationRegListData: [],
    CCExpJobShipperOrganisationRegListDataError: '',


    loadingCCExpJobConsigneeOrganisationBranchList: true,
    CCExpJobConsigneeOrganisationBranchListData: [],
    CCExpJobConsigneeOrganisationBranchListDataError: '',

    //cc -> export job -> hsn ritc codes list
    loadingCCExpJobHSNRITCCodeList: true,
    CCExpJobHSNRITCCodeListData: [],
    CCExpJobHSNRITCCodeListDataError: '',

    //custom clearance data
    loadingJobOrderListCC: false,
    jobOrderListCCData: [],
    jobOrderListCCCurrentPage: 1,
    jobOrderListCCTotalPage: 1,
    jobOrderListCCTotalData: 1,
    jobOrderListCCStatusCount: 1,

    //custom clearance data job import
    loadingJobOrderListCCImport: false,
    jobOrderListCCImportData: [],
    jobOrderListCCImportCurrentPage: 1,
    jobOrderListCCImportTotalPage: 1,
    jobOrderListCCImportTotalData: 1,
    jobOrderListCCImportStatusCount: 1,


    //cc -> export job-> currency list
    loadingCCExpJobCurrencyList: false,
    CCExpJobCurrencyListData: [],
    CCExpJobCurrencyListDataError: '',

    //cc -> export job-> airline list
    loadingCCAirlineList: false,
    CCAirlineListData: [],
    CCAirlineListDataError: '',

    //cc -> export job-> shipline list
    loadingCCShiplineList: false,
    CCShiplineListData: [],
    CCShiplineListDataError: '',

    //cc -> export job-> invoice list
    loadingCCExpJobInvoiceList: false,
    CCExpJobInvoiceListData: [],
    CCExpJobInvoiceListDataError: '',

    //cc -> import job-> invoice list
    loadingCCImpJobInvoiceList: false,
    CCImpJobInvoiceListData: [],
    CCImpJobInvoiceListDataError: '',

    //cc -> export job-> invoice detail
    loadingCCExpJobInvoiceDetail: false,
    CCExpJobInvoiceDetailData: [],
    CCExpJobInvoiceDetailDataError: '',


    //cc -> export job -> product List
    loadingCCProductList: false,
    CCProductListData: [],
    CCProductListDataError: '',


    //cc -> import job -> product List
    loadingCCProductImpList: false,
    CCProductImpListData: [],
    CCProductImpListDataError: '',

    //cc -> export job -> product detail
    loadingCCProductDetail: false,
    CCProductDetailData: {},
    CCProductDetailDataError: '',

        //cc -> import job-> Shipment list
        loadingCCImportJobShipmentList: false,
        CCImportJobShipmentListData: [],
        CCImportJobShipmentListDataError: '',
    
        //cc -> import job-> shipment detail
        loadingCCImportJobShipmentDetail: false,
        CCImportJobShipmentDetailData: [],
        CCImportJobShipmentDetailDataError: '',
    //cc -> import job -> product detail
    loadingCCProductDetailImp: false,
    CCProductDetailImpData: {},
    CCProductDetailImpDataError: '',

}

const CCImportReducer = (state = initialState, action) => {
    switch (action.type) {

        //port List//
        case 'FIND_CC_PORT_LIST_REQUEST':
            return {
                ...state,
                loadingCCPortList: true,
                CCPortListData: [],
                CCPortListDataError: '',
            };
        case 'FIND_CC_PORT_LIST_SUCCESS':
            return {
                ...state,
                loadingCCPortList: false,
                CCPortListData: action.payload,
            };
        case 'FIND_CC_PORT_LIST_FAILURE':
            return {
                ...state,
                loadingCCPortList: false,
                CCPortListDataError: action.payload,
            };
        //port List//

        //custom house List//
        case 'FIND_CC_CUSTOM_HOUSE_LIST_REQUEST':
            return {
                ...state,
                loadingCCCustomHouseList: true,
                CCCustomHouseListData: [],
                CCCustomHouseListDataError: '',
            };
        case 'FIND_CC_CUSTOM_HOUSE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCCustomHouseList: false,
                CCCustomHouseListData: action.payload,
            };
        case 'FIND_CC_CUSTOM_HOUSE_LIST_FAILURE':
            return {
                ...state,
                loadingCCCustomHouseList: false,
                CCCustomHouseListDataError: action.payload,
            };
        //custom house List//

        //employee List//
        case 'FIND_CC_EMPLOYEE_LIST_REQUEST':
            return {
                ...state,
                loadingCCEmployeeList: true,
                CCEmployeeListData: [],
                CCEmployeeListDataError: '',
            };
        case 'FIND_CC_EMPLOYEE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCEmployeeList: false,
                CCEmployeeListData: action.payload,
            };
        case 'FIND_CC_EMPLOYEE_LIST_FAILURE':
            return {
                ...state,
                loadingCCEmployeeList: false,
                CCEmployeeListDataError: action.payload,
            };
        //employee List//

        //country List//
        case 'FIND_CC_COUNTRY_LIST_REQUEST':
            return {
                ...state,
                loadingCCCountryList: true,
                CCCountryListData: [],
                CCCountryListDataError: '',
            };
        case 'FIND_CC_COUNTRY_LIST_SUCCESS':
            return {
                ...state,
                loadingCCCountryList: false,
                CCCountryListData: action.payload,
            };
        case 'FIND_CC_COUNTRY_LIST_FAILURE':
            return {
                ...state,
                loadingCCCountryList: false,
                CCCountryListDataError: action.payload,
            };
        //country List//

        //custom clearance-> export job //
        case 'FIND_CC_EXP_JOB_DETAIL_REQUEST':

            return {
                ...state,
                loadingCCExpJobDetail: true,
                CCExpJobDetailData: {},
                CCExpJobDetailDataError: '',
            };
        case 'FIND_CC_EXP_JOB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCExpJobDetail: false,
                CCExpJobDetailData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCExpJobDetail: false,
                CCExpJobDetailDataError: action.payload,
            };
        //custom clearance-> export job //

        //custom clearance-> import job //
        case 'FIND_CC_IMP_JOB_DETAIL_REQUEST':

            return {
                ...state,
                loadingCCImpJobDetail: true,
                CCImpJobDetailData: {},
                CCImpJobDetailDataError: '',
            };
        case 'FIND_CC_IMP_JOB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCImpJobDetail: false,
                CCImpJobDetailData: action.payload,
            };
        case 'FIND_CC_IMP_JOB_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCImpJobDetail: false,
                CCImpJobDetailDataError: action.payload,
            };
        //custom clearance-> import job //

        //custom clearance-> export job -> organisation list //
        case 'FIND_CC_EXP_JOB_ORGANISATION_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobOrganisationList: true,
                CCExpJobOrganisationListData: [],
                CCExpJobOrganisationListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_ORGANISATION_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobOrganisationList: false,
                CCExpJobOrganisationListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_ORGANISATION_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobOrganisationList: false,
                CCExpJobOrganisationListDataError: action.payload,
            };
        //custom clearance-> export job -> organisation list //

        //custom clearance-> export job -> organisation branch list //
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobShipperOrganisationBranchList: true,
                CCExpJobShipperOrganisationBranchListData: [],
                CCExpJobShipperOrganisationBranchListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationBranchList: false,
                CCExpJobShipperOrganisationBranchListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationBranchList: false,
                CCExpJobShipperOrganisationBranchListDataError: action.payload,
            };
        //custom clearance-> export job -> organisation reg list //
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobShipperOrganisationRegList: true,
                CCExpJobShipperOrganisationRegListData: [],
                CCExpJobShipperOrganisationRegListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationRegList: false,
                CCExpJobShipperOrganisationRegListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobShipperOrganisationRegList: false,
                CCExpJobShipperOrganisationRegListDataError: action.payload,
            };
        case 'FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobConsigneeOrganisationBranchList: true,
                CCExpJobConsigneeOrganisationBranchListData: [],
                CCExpJobConsigneeOrganisationBranchListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobConsigneeOrganisationBranchList: false,
                CCExpJobConsigneeOrganisationBranchListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobConsigneeOrganisationBranchList: false,
                CCExpJobConsigneeOrganisationBranchListDataError: action.payload,
            };
        //custom clearance-> export job -> organisation branch list //

        // custom clearance -> export job Order List
        case 'FIND_JOB_ORDER_LIST_CC_REQUEST':
            return {
                ...state,
                loadingJobOrderListCC: true,
                jobOrderListCCData: [],
                jobOrderListCCDataError: '',
            };
        case 'FIND_JOB_ORDER_LIST_CC_SUCCESS':
            return {
                ...state,
                loadingJobOrderListCC: false,
                jobOrderListCCData: action.payload.data,
                jobOrderListCCCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                jobOrderListCCTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                jobOrderListCCTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
                jobOrderListCCStatusCount: action.payload.getCount,
            };
        case 'FIND_JOB_ORDER_LIST_CC_FAILURE':
            return {
                ...state,
                loadingJobOrderListCC: false,
                jobOrderListCCDataError: action.payload,
            };
        //Job Order List//


        //cc -> export job -> hsn ritc codes list
        case 'FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobHSNRITCCodeList: true,
                CCExpJobHSNRITCCodeListData: [],
                CCExpJobHSNRITCCodeListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobHSNRITCCodeList: false,
                CCExpJobHSNRITCCodeListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobHSNRITCCodeList: false,
                CCExpJobHSNRITCCodeListDataError: action.payload,
            };
        //cc -> export job -> hsn ritc codes list


        //cc -> export job -> currency list
        case 'FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_REQUEST':

            return {
                ...state,
                loadingCCExpJobCurrencyList: true,
                CCExpJobCurrencyListData: [],
                CCExpJobCurrencyListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobCurrencyList: false,
                CCExpJobCurrencyListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobCurrencyList: false,
                CCExpJobCurrencyListDataError: action.payload,
            };
        //cc -> export job -> currency list

        //cc -> export job -> airline list
        case 'FIND_CC_AIRLINE_LIST_REQUEST':

            return {
                ...state,
                loadingCCAirlineList: true,
                CCAirlineListData: [],
                CCAirlineListDataError: '',
            };
        case 'FIND_CC_AIRLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCAirlineList: false,
                CCAirlineListData: action.payload,
            };
        case 'FIND_CC_AIRLINE_LIST_FAILURE':
            return {
                ...state,
                loadingCCAirlineList: false,
                CCAirlineListDataError: action.payload,
            };
        //cc -> export job -> airline list

        //cc -> export job -> shipine list
        case 'FIND_CC_SHIPLINE_LIST_REQUEST':

            return {
                ...state,
                loadingCCShiplineList: true,
                CCShiplineListData: [],
                CCShiplineListDataError: '',
            };
        case 'FIND_CC_SHIPLINE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCShiplineList: false,
                CCShiplineListData: action.payload,
            };
        case 'FIND_CC_SHIPLINE_LIST_FAILURE':
            return {
                ...state,
                loadingCCShiplineList: false,
                CCShiplineListDataError: action.payload,
            };
        //cc -> export job -> shipine list

        //cc -> export job -> invoice list
        case 'FIND_CC_EXP_JOB_INVOICE_LIST_REQUEST':
            return {
                ...state,
                loadingCCExpJobInvoiceList: true,
                CCExpJobInvoiceListData: [],
                CCExpJobInvoiceListDataError: '',
            };
        case 'FIND_CC_EXP_JOB_INVOICE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCExpJobInvoiceList: false,
                CCExpJobInvoiceListData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_INVOICE_LIST_FAILURE':
            return {
                ...state,
                loadingCCExpJobInvoiceList: false,
                CCExpJobInvoiceListDataError: action.payload,
            };
        //cc -> export job -> invoice list

        //cc -> import job -> invoice list
        case 'FIND_CC_IMP_JOB_INVOICE_LIST_REQUEST':
            return {
                ...state,
                loadingCCImpJobInvoiceList: true,
                CCImpJobInvoiceListData: [],
                CCImpJobInvoiceListDataError: '',
            };
        case 'FIND_CC_IMP_JOB_INVOICE_LIST_SUCCESS':
            return {
                ...state,
                loadingCCImpJobInvoiceList: false,
                CCImpJobInvoiceListData: action.payload,
            };
        case 'FIND_CC_IMP_JOB_INVOICE_LIST_FAILURE':
            return {
                ...state,
                loadingCCImpJobInvoiceList: false,
                CCImpJobInvoiceListDataError: action.payload,
            };
        //cc -> import job -> invoice list

        //cc -> export job -> invoice detail
        case 'FIND_CC_EXP_JOB_INVOICE_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCExpJobInvoiceDetail: true,
                CCExpJobInvoiceDetailData: [],
                CCExpJobInvoiceDetailDataError: '',
            };
        case 'FIND_CC_EXP_JOB_INVOICE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCExpJobInvoiceDetail: false,
                CCExpJobInvoiceDetailData: action.payload,
            };
        case 'FIND_CC_EXP_JOB_INVOICE_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCExpJobInvoiceDetail: false,
                CCExpJobInvoiceDetailDataError: action.payload,
            };
        //cc -> export job -> invoice detail

        // custom clearance -> Import job Order List
        case 'FIND_JOB_ORDER_LIST_IMPORT_CC_REQUEST':
            return {
                ...state,
                loadingJobOrderListCCImport: true,
                jobOrderListCCImportData: [],
                jobOrderListCCImportDataError: '',
            };
        case 'FIND_JOB_ORDER_LIST_IMPORT_CC_SUCCESS':
            return {
                ...state,
                loadingJobOrderListCCImport: false,
                jobOrderListCCImportData: action.payload.data,
                jobOrderListCCImportCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                jobOrderListCCImportTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                jobOrderListCCImportTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 1,
                jobOrderListCCImportStatusCount: action.payload.getCount,
            };
        case 'FIND_JOB_ORDER_LIST_IMPORT_CC_FAILURE':
            return {
                ...state,
                loadingJobOrderListCCImport: false,
                jobOrderListCCImportDataError: action.payload,
            };
        //Job Order Import List//
        //cc -> export job -> product List
        case 'FIND_CC_EXP_PRODUCT_LIST_REQUEST':
            return {
                ...state,
                loadingCCProductList: true,
                CCProductListData: [],
                CCProductListDataError: '',
            };
        case 'FIND_CC_EXP_PRODUCT_LIST_SUCCESS':
            return {
                ...state,
                loadingCCProductList: false,
                CCProductListData: action.payload,
            };
        case 'FIND_CC_EXP_PRODUCT_LIST_FAILURE':
            return {
                ...state,
                loadingCCProductList: false,
                CCProductListDataError: action.payload,
            };
        //cc -> export job -> product List

        //cc -> import job -> product List
        case 'FIND_CC_IMP_PRODUCT_LIST_REQUEST':
            return {
                ...state,
                loadingCCProductImpList: true,
                CCProductImpListData: [],
                CCProductImpListDataError: '',
            };
        case 'FIND_CC_IMP_PRODUCT_LIST_SUCCESS':
            return {
                ...state,
                loadingCCProductImpList: false,
                CCProductImpListData: action.payload,
            };
        case 'FIND_CC_IMP_PRODUCT_LIST_FAILURE':
            return {
                ...state,
                loadingCCProductImpList: false,
                CCProductImpListDataError: action.payload,
            };
        //cc -> import job -> product List

        //cc -> export job -> product detail
        case 'FIND_CC_EXP_PRODUCT_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCProductDetail: true,
                CCProductDetailData: {},
                CCProductDetailDataError: '',
            };
        case 'FIND_CC_EXP_PRODUCT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCProductDetail: false,
                CCProductDetailData: action.payload,
            };
        case 'FIND_CC_EXP_PRODUCT_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCProductDetail: false,
                CCProductDetailDataError: action.payload,
            };
        //cc -> export job -> product detail

        //cc -> import job -> shipment list
        case 'FIND_CC_IMPORT_JOB_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingCCImportJobShipmentList: true,
                CCImportJobShipmentListData: [],
                CCImportJobShipmentListDataError: '',
            };
        case 'FIND_CC_IMPORT_JOB_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingCCImportJobShipmentList: false,
                CCImportJobShipmentListData: action.payload,
            };
        case 'FIND_CC_IMPORT_JOB_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingCCImportJobShipmentList: false,
                CCImportJobShipmentListDataError: action.payload,
            };
        //cc -> export job -> shipment list

        //cc -> export job -> shipment detail
        case 'FIND_CC_IMPORT_JOB_SHIPMENT_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCImportJobShipmentDetail: true,
                CCImportJobShipmentDetailData: [],
                CCImportJobShipmentDetailDataError: '',
            };
        case 'FIND_CC_IMPORT_JOB_SHIPMENT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCImportJobShipmentDetail: false,
                CCImportJobShipmentDetailData: action.payload,
            };
        case 'FIND_CC_IMPORT_JOB_SHIPMENT_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCImportJobShipmentDetail: false,
                CCImportJobShipmentDetailDataError: action.payload,
            };
        //cc -> export job -> shipment detail
        //cc -> import job -> product detail
        case 'FIND_CC_IMP_PRODUCT_DETAIL_REQUEST':
            return {
                ...state,
                loadingCCProductDetailImp: true,
                CCProductDetailImpData: {},
                CCProductDetailImpDataError: '',
            };
        case 'FIND_CC_IMP_PRODUCT_DETAIL_SUCCESS':
            return {
                ...state,
                loadingCCProductDetailImp: false,
                CCProductDetailImpData: action.payload,
            };
        case 'FIND_CC_IMP_PRODUCT_DETAIL_FAILURE':
            return {
                ...state,
                loadingCCProductDetailImp: false,
                CCProductDetailImpDataError: action.payload,
            };
        //cc -> import job -> product detail

        default:
            return state;
    }
}

export default CCImportReducer;